import React from 'react';
import { Props } from './UWTable.types';
import styles from './UWTable.module.scss';
import UWTableHeader from '../UWTableHeader/UWTableHeader';
import UWTableRows from '../UWTableRows/UWTableRows';

const UWTable: React.FC<Props> = ({ title, titles = [], rows }) => {
  return (
    <div className={styles.tableSection}>
      {title && <h3>{title}</h3>}
      <table>
        <tbody>
          {titles.length > 0 && <UWTableHeader header={titles} />}
          <UWTableRows rows={rows} />
        </tbody>
      </table>
    </div>
  );
};

export default UWTable;
